import { Pipe, PipeTransform } from '@angular/core';
import { SelectOption } from '@fleet-beat/core';
import { ViolationTypeEnum, ViolationTypeOptions } from '../enums/logbook';

@Pipe({
  name: 'logBookViolationPipe',
})
export class LogBookViolationPipe implements PipeTransform {
  transform(value: ViolationTypeEnum): string | null {
    if (!value) return null;
    return ViolationTypeOptions.find((item: SelectOption) => item.value === value).label;
  }
}
